/* 🤖 this file was generated by script */
export const wsolidiconHeart = {
  name: 'heart',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M12 3.72c-2.35-2.05-5.8-2.47-8.5-.17a6.96 6.96 0 0 0-1.03 9.62 47 47 0 0 0 4.22 4.36 185 185 0 0 0 4.4 4 1.5 1.5 0 0 0 1.33.24q.32-.1.48-.25.14-.1.26-.22l.02-.01c.81-.72 2.46-2.2 4.12-3.76a47 47 0 0 0 4.21-4.36 6.9 6.9 0 0 0-1.04-9.63 6.37 6.37 0 0 0-8.48.18" clip-rule="evenodd"/></svg>`,
  iconStyle: 'solid',
};
